import dispatchEvent from '../utils/dispatch-event.js';
import formatMoney from '../utils/currency.js';
import { addToCart } from '../modules/cart.js';

const selectors = {
  atcButton: '[data-quick-atc]',
  variantSelector: '[data-quick-atc-variant-selector]',
  selectedPrice: '[data-price]',
  selectedCompareAtPrice: '[data-compare-at-price]',
  atcVariantId: '[data-atc-id]',
};

class QuickAdd extends HTMLElement {
  constructor() {
    super();

    this.atcButton = this.querySelector(selectors.atcButton);
    this.variantSelector = this.querySelector(selectors.variantSelector);
    this.selectedPrice = this.querySelector(selectors.selectedPrice);
    this.selectedCompareAtPrice = this.querySelector(
      selectors.selectedCompareAtPrice
    );

    this.registerEventListeners();
  }

  setPriceText(price) {
    this.selectedPrice.textContent = formatMoney(price);
  }

  setCompareAtPriceText(compareAtPrice) {
    this.selectedCompareAtPrice.textContent = formatMoney(compareAtPrice);
  }

  setId(id) {
    this.atcButton.dataset.atcId = id;
  }

  setAvailability(availability) {
    this.atcButton.dataset.isAvailable = availability;
  }

  getId() {
    return Number(this.atcButton.dataset.atcId);
  }

  addToCart() {
    addToCart(
      {
        items: [
          {
            id: this.getId(),
            quantity: 1,
          },
        ],
      },
      {
        element: this.atcButton,
        eventOptions: {
          detail: { action: 'open-cart' },
        },
      }
    ).then(() => dispatchEvent('cart:quantity-updated', document));
  }

  registerEventListeners() {
    if (this.variantSelector) {
      this.variantSelector.addEventListener('change', ({ target }) => {
        const { options, selectedIndex } = target;

        this.setPriceText(options[selectedIndex].dataset.variantPrice);
        if (options[selectedIndex].dataset.variantCompareAtPrice) {
          if (options[selectedIndex].dataset.variantCompareAtPrice > 0) {
            this.setCompareAtPriceText(
              options[selectedIndex].dataset.variantCompareAtPrice
            );
            this.selectedCompareAtPrice.style.visibility = 'visible';
          } else {
            this.selectedCompareAtPrice.style.visibility = 'hidden';
          }
        }
        this.setId(options[selectedIndex].dataset.variantId);
        this.setAvailability(options[selectedIndex].dataset.available);
      });
    }

    this.atcButton.addEventListener('click', () => this.addToCart());
  }
}

customElements.define('quick-add', QuickAdd);
